export default __webpack_public_path__ + "static/media/default.f582d7c112a9803cd39b2ec7d1f037a2.svg";